import Http from "./http";
import { The_Ability } from "../store/index";

export default {
  index(filter) {
    return Http.get(`/action_plans.json`, {
      params: {
        solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  exportCsv(filter) {
    // return http.get("/done_forms/"+id+".pdf", { responseType: 'blob' })
    return Http.get(`/action_plans.csv`, {
      responseType: 'blob',
      params: {
        solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  indexKanban(filter) {
    // let search = ''
    const {limit, page, level, ...f} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/action_plans.json`, {
      params: {
        solution_id: localStorage.getItem("solution_id"),
        limit, 
        page, 
        status: level,
        ...f,
      }
    })
  },

  show(id) {
    return Http.get(`/action_plans/${id}`);
  },

  update(action_plan) {
    return Http.put(`/action_plans/${action_plan.id}`, {
      action_plan: {
        ...action_plan
      }
    });
  },

  delete(id){
    return Http.delete(`/action_plans/${id}`);
  },
};
